import React from "react";
import Button from "helpers/button";

import {
  getHorizontalAlign,
  getVerticalAlign,
  getFlexDirection,
} from "helpers/get-section-align";

const gradinetStyle = {
  indigo: "from-indigo-800",
  green: "from-green-700",
  none: "",
};

const backgroundColor = {
  indigo: " bg-indigo-800",
  green: " bg-green-700",
  none: "",
};

const textColor = {
  white: " !text-white",
  green: " !text-green-700",
  yellow: " !text-yellow-400",
};

const FooterCta = ({ data }) => {
  const {
    overlayColor,
    backgroundImage,
    mobileBackgroundImage,
    elementsDirection: { elementsDirection },
    horizontalAlign: { horizontalAlign },
    verticalAlign: { verticalAlign },
    title,
    description,
    buttons,
    descriptionColor,
    fullwidthBGImage,
  } = data?.footerCta || data;

  return (
    <div 
      style={{ 
        backgroundImage: mobileBackgroundImage ? `url(${mobileBackgroundImage.src})` : "none",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }} 
      className={`relative min-h-[330px] flex items-center sm:inline-block bg-gradient-to-r ${backgroundColor[overlayColor]}`}
    >
      {backgroundImage && (
        <div className="w-full h-full absolute top-0 left-0 flex justify-end sm:relative sm:h-96">
          <div className={`${fullwidthBGImage ? "w-full absolute h-full" : "w-7/12 relative"} flex sm:w-full`}>
            {overlayColor && (
              <div
                className={`w-full h-full absolute top-0 left-0 z-[2] bg-gradient-to-r sm:bg-gradient-to-t ${gradinetStyle[overlayColor]}`}
              />
            )}
            <img
              src={backgroundImage?.src}
              alt={backgroundImage?.alt}
              className={`w-full h-full object-cover ${(backgroundImage && mobileBackgroundImage) && "sm:hidden"}`}
            />
          </div>
        </div>
      )}

      <div className="container w-full relative z-[3] py-16">
        <div
          className={`flex gap-6 w-full sm:flex-col sm:items-center sm:justify-center
          ${getFlexDirection(elementsDirection)} 
          ${getHorizontalAlign(horizontalAlign, elementsDirection)} 
          ${getVerticalAlign(verticalAlign, elementsDirection)}`}
        >
          <div className="sm:text-center">
            <h2
              className={`header ${textColor[descriptionColor]} ${backgroundImage ? "sm:!text-h1 sm:leading-snug" : ""
                }`}
            >
              {title}
            </h2>
            {description && (
              <p className="font-montserrat text-lg sm:text-base text-white my-6 max-w-xl sm:max-w-none">{description}</p>
            )}
          </div>
          {buttons && (
            <div className="flex items-center gap-4">
              {buttons.map((button, index) => (
                <Button button={button} key={index} />  
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FooterCta;
